/* eslint-disable max-len */
import React, {Fragment} from 'react';

const svgs = {
    CHECKED: {
        viewBox: '0 0 18 18',
        data: (
            <Fragment>
                <rect x="1" y="1" width="16" height="16" rx="1" fill="white" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M13.5,6 L7.5,12 L5,9.5" strokeWidth="2" stroke="#242424" fill="transparent" strokeLinecap="round" strokeLinejoin="round" />
            </Fragment>
        )
    },
    UNCHECKED: {
        viewBox: '0 0 18 18',
        data: (
            <rect x="1" y="1" width="16" height="16" rx="1" stroke="white" fill="transparent" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        )
    },
    CARET: {
        viewBox: '0 0 8 4',
        data: (
            <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M0.0981641 0.095083C0.230492 -0.0303711 0.446864 -0.0318595 0.58147 0.0916808L4.00014 3.23356L7.4188 0.0916808C7.55318 -0.0318595 7.76955 -0.0303711 7.90188 0.095083C8.03421 0.22075 8.03239 0.422752 7.89824 0.54608L4.23974 3.90846C4.10673 4.03051 3.89355 4.03051 3.76053 3.90846L0.102036 0.54608C0.034164 0.483778 0 0.401276 0 0.318987C0 0.238186 0.0327973 0.157172 0.0981641 0.095083Z" fill="white" />
        )
    },
    FILE: {
        viewBox: '0 0 24 24',
        data: (
            <path fillRule="evenodd" clipRule="evenodd" d="M19.75 19.5C19.75 20.7426 18.7426 21.75 17.5 21.75H6.5C5.25736 21.75 4.25 20.7426 4.25 19.5V4.5C4.25 3.25736 5.25736 2.25 6.5 2.25H13.3787C13.9754 2.25 14.5477 2.48705 14.9697 2.90901L19.091 7.03033C19.5129 7.45229 19.75 8.02458 19.75 8.62132V19.5ZM5.75 4.5C5.75 4.08579 6.08579 3.75 6.5 3.75H12.25V8C12.25 8.9665 13.0335 9.75 14 9.75H18.25V19.5C18.25 19.9142 17.9142 20.25 17.5 20.25H6.5C6.08579 20.25 5.75 19.9142 5.75 19.5V4.5ZM18.1516 8.25H14C13.8619 8.25 13.75 8.13807 13.75 8V3.84837C13.8077 3.88124 13.8612 3.9219 13.909 3.96967L18.0303 8.09099C18.0781 8.13876 18.1188 8.19231 18.1516 8.25Z" fill="white" />
        )
    },
    DOWNLOAD: {
        viewBox: '0 0 24 24',
        data: (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M9.99968 1.75C10.4139 1.75 10.7497 2.08579 10.7497 2.5V12.356L12.8027 10.303C13.0956 10.0101 13.5704 10.0101 13.8633 10.303C14.1562 10.5959 14.1562 11.0708 13.8633 11.3637L9.99968 15.2273L6.13601 11.3637C5.84312 11.0708 5.84312 10.5959 6.13601 10.303C6.4289 10.0101 6.90378 10.0101 7.19667 10.303L9.24968 12.356V2.5C9.24968 2.08579 9.58546 1.75 9.99968 1.75Z" fill="white" />
                <path fillRule="evenodd" clipRule="evenodd" d="M3.33301 13.4167C3.74722 13.4167 4.08301 13.7525 4.08301 14.1667V16.25C4.08301 16.5261 4.30686 16.75 4.58301 16.75H15.4163C15.6925 16.75 15.9163 16.5261 15.9163 16.25V14.1667C15.9163 13.7525 16.2521 13.4167 16.6663 13.4167C17.0806 13.4167 17.4163 13.7525 17.4163 14.1667V16.25C17.4163 17.3546 16.5209 18.25 15.4163 18.25H4.58301C3.47844 18.25 2.58301 17.3546 2.58301 16.25V14.1667C2.58301 13.7525 2.91879 13.4167 3.33301 13.4167Z" fill="white" />
            </svg>


        )
    }
};

export default svgs;
/* eslint-enable max-len */
